import { render, staticRenderFns } from "./settingsGroupsView.vue?vue&type=template&id=107062a0"
import script from "./settingsGroupsView.vue?vue&type=script&lang=js"
export * from "./settingsGroupsView.vue?vue&type=script&lang=js"
import style0 from "./settingsGroupsView.vue?vue&type=style&index=0&id=107062a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports